import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../core/api/queryKeys';
import { getDashboard } from '../api/dashboardApi';

export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard.all,
    queryFn: getDashboard,
    refetchInterval: 60_000,
  });
}
